module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f5e78869d96cc5123a3cf0864938f2f8.png";